import { Button } from "@/lib/components/Button/Button";
import FetchRealEstateListing from "./FetchRealEstateListingForm";
import { useState } from "react";

type Props = {
  isVisible: boolean;
};

export default function OpenScraperButton({ isVisible }: Props) {
  const [isRealEstateListingFormOpen, setIsRealEstateListingFormOpen] =
    useState(false);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <p className="my-4 ml-6 text-center text-sm font-semibold">or</p>
      <Button
        className="ml-6"
        variant="outline"
        onClick={() => setIsRealEstateListingFormOpen(true)}
      >
        Import from Zillow or Rightmove
      </Button>
      <FetchRealEstateListing
        open={isRealEstateListingFormOpen}
        setOpen={setIsRealEstateListingFormOpen}
      />
    </>
  );
}
